import apiClient from './apiClient';

const packageService = {
  getAll: () => apiClient.get('/rates/packages/'),
  getById: (id) => apiClient.get(`/rates/packages/${id}/`),
  create: (data) => apiClient.post('/rates/packages/', data),
  update: (id, data) => apiClient.patch(`/rates/packages/${id}/`, data),
  remove: (id) => apiClient.del(`/rates/packages/${id}/`),
  getRatePlans: () => apiClient.get('/rates/plans/'),
};

export default packageService;
